module.exports = __webpack_public_path__ + "img/shaixuan.9b908ad6.png";